<template>
  <div class="Site PageBox" style="background-color: var(--background-main)">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('login.text[3]')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="Login ScrollBox">
      <van-form class="mt15" @submit="onSubmit">
        <input
          type="text"
          autocomplete="off"
          style="position: absolute;opacity:0;z-index:-1"
        />
        <input
          type="password"
          autocomplete="off"
          style="position: absolute;opacity:0;z-index:-1"
        />
        <van-field
          v-if="verifyType=='phone'"
          v-model.trim="postData.username"
          :border="false"
          left-icon="phone"
          :placeholder="$t('register.placeholder[0]')"
          clearable
          autocomplete="off"
          key="phone"
          label-width="auto"
        >
          <template #label>
            <van-dropdown-menu>
              <van-dropdown-item :title="`+${postData.dest}`" ref="DropdownItem">
                <template>
                  <ul>
                    <li v-for="(item,index) in areaList" :key="index" :class="{on:postData.dest==item.id}" @click="postData.dest=item.id,$refs.DropdownItem.toggle()">+{{item.id}}&#12288;{{item.name}}</li>
                  </ul>
                </template>
              </van-dropdown-item>
            </van-dropdown-menu>
          </template>
        </van-field>
        <van-field
          v-if="verifyType=='mail'"
          left-icon="comment"
          v-model.trim="postData.username"
          :placeholder="$t('Register[0]')"
          clearable
          autocomplete="off"
          :border="false"
          key="email"
        />
        <!-- <van-field
          left-icon="coupon"
          v-model.trim="postData.code"
          autocomplete="off"
          type="digit"
          :placeholder="$t('register.placeholder[6]')"
          clearable
          :border="false"
        >
          <template #button>
            <van-image width="100" height="34" :src="codeImg" style="display: block;cursor: pointer;" @click="getCode" />
          </template>
        </van-field> -->
        <van-field
          left-icon="coupon"
          v-model.trim="postData.smscode"
          autocomplete="off"
          type="digit"
          :placeholder="verifyType=='phone'?$t('register.placeholder[1]'):$t('Register[1][0]')"
          clearable
          :border="false"
        >
          <template #button>
            <van-button size="mini" type="info" :color="isSendCode?'var(--color-assist)':''" round native-type="button" :disabled="isSendCode" @click="verifyType=='phone'?getSmsCode():getMailCode()">{{verifyType=='phone'?$t('register.text[2]'):$t('Register[1][1]')}}{{isSendCode?`(${sendTime}s)`:''}}</van-button>
          </template>
        </van-field>
        <van-field
          left-icon="lock"
          v-model.trim="postData.password"
          type="password"
          :placeholder="$t('register.placeholder[2]')"
          clearable
          autocomplete="off"
          :border="false"
        />
        <van-field
          left-icon="lock"
          type="password"
          v-model.trim="postData.re_password"
          :placeholder="$t('register.placeholder[3]')"
          clearable
          autocomplete="off"
          :border="false"
        />
        <div style="padding: 15px;">
          <van-button block type="danger" round :loading="isSubmit" :loading-text="$t('dialog[2]')" style="font-size: 16px;">{{$t('userSet.default[3]')}}</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Setting',
  components: {
  },
  props: ['verifyType'],
  data() {
    return {
      postData: {
        type: this.verifyType,
        dest: areaList[0].id,
        username: '',
        mail: '',
        password: '',
        re_password: '',
        smscode: '',
        code: '',
        code_rand: '',
      },
      isSubmit: false,
      codeImg: '',
      areaList: areaList,
      isSendCode: false,
      downTimer: null,
      sendTime: 60,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    if(this.verifyType=='phone'){
      this.$Model.SmsCode((data) => {
        this.areaList = data
        this.postData.dest = data[0].id
      })
    }
    // this.getCode()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    clearInterval(this.downTimer)
  },
  methods: {
    getCode() {
      this.postData.code_rand = new Date().getTime()
      this.codeImg = this.ApiUrl+'/api/Account/code?code_rand='+this.postData.code_rand
    },
    onSubmit() {
      if(this.verifyType=='mail'){
        this.postData.mail = this.postData.username
      }
      if(!this.postData.username){
        if(this.verifyType=='phone'){
          this.$Dialog.Toast(this.$t('register.placeholder[0]'))
        }else{
          this.$Dialog.Toast(this.$t('Register[0]'))
        }
        return
      }
      if(!this.postData.smscode){
        if(this.verifyType=='phone'){
          this.$Dialog.Toast(this.$t('register.placeholder[1]'))
        }else{
          this.$Dialog.Toast(this.$t('Register[1][0]'))
        }
        return
      }
      if(!this.postData.password){
        this.$Dialog.Toast(this.$t('register.placeholder[2]'))
        return
      }
      if(!this.postData.re_password){
        this.$Dialog.Toast(this.$t('register.placeholder[3]'))
        return
      }
      if(this.postData.password!=this.postData.re_password){
        this.$Dialog.Toast(this.$t('register.placeholder[5]'))
        return
      }
      this.isSubmit = true
      this.$Model.RetrievePassword(this.postData,data=>{
        this.isSubmit = false
        // this.getCode()
      });
    },
    countDown() {
      this.downTimer = setInterval(()=>{
        this.sendTime --
        if(this.sendTime<0){
          this.isSendCode = false
          this.sendTime = 60
          clearInterval(this.downTimer)
        }
      },1000)
    },
    getMailCode() {
      if(!this.postData.username){
        this.$Dialog.Toast(this.$t('Register[0]'));
        return;
      }
      this.isSendCode = true
      this.countDown()
      this.$Model.GetMailCode({mail: this.postData.username, code: this.postData.code, code_rand: this.postData.code_rand,type: 'password'},(data)=>{
        if(data.code!=1){
          // this.getCode()
        }else{
          this.$Dialog.Alert(data.code_dec)
        }
      })
    },
    getSmsCode() {
      if(!this.postData.username){
        this.$Dialog.Toast(this.$t('register.placeholder[0]'))
        return
      }
      this.isSendCode = true
      this.countDown()
      this.$Model.GetSMSCode({phone: this.postData.username,dest: this.postData.dest, code: this.postData.code, code_rand: this.postData.code_rand,type: 'password'},(data)=>{
        if(data.code!=1){
          // this.getCode()
        }else{
          this.$Dialog.Alert(data.code_dec)
        }
      })
    },
  }
}
</script>
<style scoped>
.van-dropdown-menu>>>.van-dropdown-menu__bar{
  height: auto;
  box-shadow: none;
  background: transparent;
}
.van-dropdown-menu>>>.van-dropdown-menu__title{
  padding: 0 10px 0 0;
  margin-right: 10px;
  line-height: 1;
  font-size: inherit;
}
.van-dropdown-menu>>>.van-dropdown-item__content ul{
  padding: 0 15px;
}
.van-dropdown-menu>>>.van-dropdown-item__content ul li{
  padding: 8px 0;
  width: 100%;
  font-size: 14px;
}
</style>